import { ClassCodeComboBoxModel } from '../class-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 部門情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetClassListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetClassListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: ClassCodeComboBoxModel;
  private orderCode: string = null;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetClassListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {ClassCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetClassListService
   */
  execute(model: ClassCodeComboBoxModel, orderCode: string, successFunc: () => void = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.successFunc = successFunc;
    this.send('KYMW02getClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetClassListService
   */
  success(data: any[]) {
    this.model.updateClassList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
